export namespace ECOMMERCE_RULE_FEATURE {
    export const SHOW_ADD_TO_QUOTE = "showAddToQuoteRules"
    export const HIDE_ADD_TO_CART_BUTTON_RULES = "hideAddToCartButtonRules"
    export const HIDE_PRICES_RULES = "hidePricesRules"
}
export type ECOMMERCE_RULE_FEATURE = typeof ECOMMERCE_RULE_FEATURE[keyof typeof ECOMMERCE_RULE_FEATURE];


// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceRuleFeatures.ts